import {
	REZA_OVERVIEW_FORM_PERMISSIONS,
	useOverviewForm,
} from '@gov-nx/module/page';
import { Button, Dialog, LayoutGap } from '@gov-nx/ui/web';
import { OverviewForm } from './OverviewForm';
import { useRezaChangeOptions } from '@gov-nx/core/hooks';
import { RezaChangeFormSection } from '../../Reza/RezaChangeFormView/RezaChangeFormSection';
import { RezaChangeFormSkeleton } from '../../Reza/RezaChangeFormView/RezaChangeFormSkeleton';
import { useRezaSwitcherStore } from '@gov-nx/store';

interface UsageModalFormProps {
	isOpen: boolean;
	onClose: () => void;
}

export const OverviewModalForm = ({ isOpen, onClose }: UsageModalFormProps) => {
	const { setActiveSwitcherReza } = useRezaSwitcherStore();
	const optionsData = useRezaChangeOptions({
		permissions: REZA_OVERVIEW_FORM_PERMISSIONS,
	});

	const {
		formDefinition,
		formId,
		strings,
		isSentByDatabox,
		hasDataBoxes,
		isLoading,
		onSubmit,
	} = useOverviewForm();

	return (
		<Dialog
			isOpen={isOpen}
			onClose={() => {
				setActiveSwitcherReza(null);
				onClose();
			}}
			title={<h3>{strings.title}</h3>}
			footer={
				<Button
					form={formId}
					isLoading={isLoading}
					isDisabled={optionsData.isRezaListLoading}
					nativeType="submit"
					color="primary"
					type="solid">
					{strings.submitButton}
				</Button>
			}>
			<LayoutGap>
				{optionsData.isRezaListLoading ? (
					<RezaChangeFormSkeleton />
				) : (
					<RezaChangeFormSection
						optionsData={optionsData}
						setActiveSwitcherReza={setActiveSwitcherReza}
						autoSubmitOnChange
					/>
				)}
				<OverviewForm
					formId={formId}
					formDefinition={formDefinition}
					isSentByDatabox={isSentByDatabox}
					hasDataBoxes={hasDataBoxes}
					onSubmit={onSubmit}
				/>
			</LayoutGap>
		</Dialog>
	);
};
